import { useRouter } from "next/router";
import { ReactNode, useEffect } from "react";

import { Box } from "@chakra-ui/react";
import {
  HStack,
  customEvent,
  colors,
  icon,
  VStack,
  ColorIcon,
  // call,
  GOI_PLATFORM_URL,
  responsive,
  Image,
  getCdnImageSrc,
} from "goi_common";
import { useOpenFlowerModal } from "@/hooks/useOpenFlowerModal";
import { PARLOR_FAMILY_MAIN_PATH } from "../constants/event";

import { useGoiCall } from "@/hooks/useGoiCall";

interface MissParlorDetailBadgeCTASectionProps {
  companyName: string;
}

export const MissParlorDetailBadgeCTASection = ({
  companyName,
}: MissParlorDetailBadgeCTASectionProps) => {
  const router = useRouter();
  const { query } = router;
  const { id } = query;
  const { goiCall } = useGoiCall();
  const { openFlowerModal } = useOpenFlowerModal({
    companyName,
    parlorId: id as string,
  });

  useEffect(() => {
    if (router.query.showFlowerModal === "true") {
      openFlowerModal();
    }
  }, [router.query]);

  return (
    <section
      css={responsive({
        width: "100%",
        position: {
          lg: "absolute",
        },
        background: {
          lg: "#00000080",
        },
        bottom: 0,
        padding: "20px",
      })}
    >
      <HStack gap={4} justifyContent="center">
        <BadgeIcon
          icon="mingcute_sunflower_line"
          title="화환 보내기"
          backgroundColor={colors.blue750}
          color={colors.white}
          onClick={() => {
            customEvent({
              newGtm: {
                path: PARLOR_FAMILY_MAIN_PATH,
                trigger_and_target: "btn-hwahwan",
                text: companyName,
              },
            });

            router.replace({
              query: { ...query, showFlowerModal: true },
            });
          }}
        />
        <BadgeIcon
          icon="icon-call-mono"
          title="장례 상담"
          backgroundColor={colors.warmGray750}
          color={colors.white}
          onClick={() => {
            customEvent({
              newGtm: {
                path: PARLOR_FAMILY_MAIN_PATH,
                trigger_and_target: "btn-hwahwan",
                text: companyName,
              },
            });

            goiCall();
            // call("1666-9784");
          }}
        />
        <BadgeIcon
          icon="ph_coin_bold"
          title="장례 견적"
          backgroundColor={colors.gray600}
          color={colors.white}
          onClick={() => {
            customEvent({
              newGtm: {
                path: PARLOR_FAMILY_MAIN_PATH,
                trigger_and_target: "btn-uv-htch_rqst_prlr",
                text: companyName,
              },
            });

            router.push(`${GOI_PLATFORM_URL}/match/parlor-requests/${id}/`);
          }}
        />

        <div
          css={responsive({
            display: {
              base: "none",
              lg: "block",
            },
            position: "relative",
            minWidth: "266px",
          })}
        >
          <Image
            src={getCdnImageSrc("parlor-platform/lg-call-banner.jpg")}
            css={{
              position: "absolute",
              cursor: "pointer",
              bottom: 0,
              width: "266px",
              minHeight: "133px",
              objectFit: "cover",
            }}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: PARLOR_FAMILY_MAIN_PATH,
                  trigger_and_target: "goi_call",
                },
              });

              goiCall();
              // call("1666-9784");
            }}
            alt="call-banner"
          />
        </div>
      </HStack>
    </section>
  );
};

interface BadgeIconProps {
  icon: keyof typeof icon;
  title: ReactNode;
  onClick: () => void;
  hasBorder?: boolean;
  backgroundColor: string;
  color: string;
}

const BadgeIcon = ({
  icon,
  title,
  onClick,
  color,
  backgroundColor,
}: BadgeIconProps) => {
  return (
    <VStack
      css={responsive({
        width: {
          base: "100%",
          lg: "194px",
        },
        padding: {
          base: "6px 0",
          lg: "18px 60px",
        },
        borderRadius: "4px",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color,
      })}
      background={backgroundColor}
      onClick={onClick}
    >
      {icon && <ColorIcon name={icon} size={24} color={color} />}
      {title && (
        <Box
          className="subtitle_16_sb"
          textAlign="center"
          whiteSpace="pre"
          color={color}
        >
          {title}
        </Box>
      )}
    </VStack>
  );
};
